// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-LinkButton__linkButton__root cmp-components__clickable__root"};